import type { FeatureFlagRequirement } from '@redviking/argonaut-util/src/feature-flags';
import type { RouteRecord, RouteRecordPublic } from 'vue-router';

export function getRouteFeatureFlags (route: RouteRecordPublic | RouteRecord): FeatureFlagRequirement[] | null {
    /**
     * if `null`, no feature flag requirement is unspecified, and this
     * route will be considered unnavigatable.
     * To allow a navigation without requiring a feature flag, set the
     * route's `meta.featureFlags = []`
     */
    let featureFlagsReqs: FeatureFlagRequirement[] | null = null;
    if (route.parent) {
        const parentFeatureFlags = getRouteFeatureFlags(route.parent);
        if (parentFeatureFlags) {
            featureFlagsReqs = parentFeatureFlags;
        }
    }
    if (route.meta?.featureFlags) {
        const routeFeatureFlags = route.meta.featureFlags as FeatureFlagRequirement[];
        featureFlagsReqs = [
            ...featureFlagsReqs || [],
            ...routeFeatureFlags,
        ];
    }
    return featureFlagsReqs;
}
